module.exports = __webpack_public_path__ + "img/Board_BingoV2.cc9b4ae8.png";